import { useRef } from 'react';
import { createTokenManager } from '../utility/tokenManager';
const useTokenManager = (localStorageKey = null) => {
	const tokenManagerRef = useRef(createTokenManager(localStorageKey));

	return tokenManagerRef.current;
};

export default useTokenManager;
